<div class="tabs">
  <a class="logo" routerLink="/"></a>
  <h5 routerLink="." i18n>Edit Tag</h5>
  <app-settings />
</div>
@if (!loaded()) {
  <app-loading />
} @else if (!store.view.ext()) {
  <form class="form" [formGroup]="extForm" (ngSubmit)="create()">
    <label for="tag"></label>
    <div class="form-array">
      <app-select-template [(template)]="template" />
      <input id="tag"
             name="tag"
             i18n-placeholder
             placeholder="Extend Tag..."
             class="big"
             type="email"
             autocorrect="off"
             autocapitalize="none"
             formControlName="tag"
             [readonly]="!loaded()"
             (blur)="validate($any($event.target))">
    </div>

    @for (e of serverError(); track e) {
      <span><!-- Unexpected Error --></span>
      <div class="error">{{ e }}</div>
    }

    <span><!-- Buttons --></span>
    <span class="buttons right floating">
      @if (creating()) {
        <app-loading [inline]="true" />
      }
      <button type="submit" [disabled]="!loaded() || creating() || submitted() && !extFormValid()" i18n>Extend</button>
    </span>
  </form>
} @else if (editForm(); as editForm) {
  <form class="form"
        [formGroup]="editForm"
        (ngSubmit)="save()">
    <app-ext-form [group]="editForm"
                  [ext]="ext()"
                  [showClear]="true"
                  (clear)="clear()" />

    @for (e of serverError(); track e) {
      <span><!-- Unexpected Error --></span>
      <div class="error">{{ e }}</div>
    }

    <span><!-- Buttons --></span>
    <span class="buttons right floating">
      @if (overwritten()) {
        <div class="overwrite warning" i18n-title title="Will drop all unknown configs.">
          <input id="overwrite" type="checkbox" [checked]="overwrite" (input)="overwrite = !overwrite">
          <label for="overwrite" i18n>Overwrite</label>
        </div>
      }
      @if (editing() || deleting()) {
        <app-loading [inline]="true" />
      }
      <button type="submit" [disabled]="editing() || deleting() || submitted() && !editFormValid()" i18n>Save</button>
        <button type="button" [disabled]="editing() || deleting()" (click)="delete()" i18n>Delete</button>
    </span>
  </form>
}
